/* tslint:disable */
/* eslint-disable */
/**
 * Armasuisse Dashboard Web Application API
 * API definitions for Armasuisse Dashboard Web Application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MilestoneType } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { ProjectMilestoneBase } from '../models';
// @ts-ignore
import { ProjectMilestoneBaseResponse } from '../models';
/**
 * ProjectMilestonesApi - axios parameter creator
 * @export
 */
export const ProjectMilestonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates new Project Milestone and returns newly created Project Milestone.
         * @summary Creates new Project Milestone.
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectMilestone: async (projectMilestoneBase?: ProjectMilestoneBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProjectMilestones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectMilestoneBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Project Milestone.
         * @summary Delete Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectMilestone: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('deleteProjectMilestone', 'entityID', entityID)
            const localVarPath = `/ProjectMilestones/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Project Milestone.
         * @summary Get Project Milestone details.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMilestoneDetails: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('getProjectMilestoneDetails', 'entityID', entityID)
            const localVarPath = `/ProjectMilestones/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of Project Milestones.
         * @summary Get filtered list of Project Milestones.
         * @param {MilestoneType} [type] Milestone type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMilestoneList: async (type?: MilestoneType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ProjectMilestones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Project Milestone and returns the modified Project Milestone.
         * @summary Edit Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectMilestone: async (entityID: number, projectMilestoneBase?: ProjectMilestoneBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('updateProjectMilestone', 'entityID', entityID)
            const localVarPath = `/ProjectMilestones/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectMilestoneBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectMilestonesApi - functional programming interface
 * @export
 */
export const ProjectMilestonesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectMilestonesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates new Project Milestone and returns newly created Project Milestone.
         * @summary Creates new Project Milestone.
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProjectMilestone(projectMilestoneBase?: ProjectMilestoneBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectMilestoneBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProjectMilestone(projectMilestoneBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete Project Milestone.
         * @summary Delete Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectMilestone(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectMilestone(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the Project Milestone.
         * @summary Get Project Milestone details.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectMilestoneDetails(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectMilestoneBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectMilestoneDetails(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of Project Milestones.
         * @summary Get filtered list of Project Milestones.
         * @param {MilestoneType} [type] Milestone type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectMilestoneList(type?: MilestoneType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectMilestoneBaseResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectMilestoneList(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Project Milestone and returns the modified Project Milestone.
         * @summary Edit Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectMilestone(entityID: number, projectMilestoneBase?: ProjectMilestoneBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectMilestoneBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectMilestone(entityID, projectMilestoneBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectMilestonesApi - factory interface
 * @export
 */
export const ProjectMilestonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectMilestonesApiFp(configuration)
    return {
        /**
         * Creates new Project Milestone and returns newly created Project Milestone.
         * @summary Creates new Project Milestone.
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectMilestone(projectMilestoneBase?: ProjectMilestoneBase, options?: any): AxiosPromise<ProjectMilestoneBaseResponse> {
            return localVarFp.addProjectMilestone(projectMilestoneBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Project Milestone.
         * @summary Delete Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectMilestone(entityID: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProjectMilestone(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Project Milestone.
         * @summary Get Project Milestone details.
         * @param {number} entityID Project Milestone identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMilestoneDetails(entityID: number, options?: any): AxiosPromise<ProjectMilestoneBaseResponse> {
            return localVarFp.getProjectMilestoneDetails(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of Project Milestones.
         * @summary Get filtered list of Project Milestones.
         * @param {MilestoneType} [type] Milestone type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectMilestoneList(type?: MilestoneType, options?: any): AxiosPromise<Array<ProjectMilestoneBaseResponse>> {
            return localVarFp.getProjectMilestoneList(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Project Milestone and returns the modified Project Milestone.
         * @summary Edit Project Milestone.
         * @param {number} entityID Project Milestone identifier
         * @param {ProjectMilestoneBase} [projectMilestoneBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectMilestone(entityID: number, projectMilestoneBase?: ProjectMilestoneBase, options?: any): AxiosPromise<ProjectMilestoneBaseResponse> {
            return localVarFp.updateProjectMilestone(entityID, projectMilestoneBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectMilestonesApi - object-oriented interface
 * @export
 * @class ProjectMilestonesApi
 * @extends {BaseAPI}
 */
export class ProjectMilestonesApi extends BaseAPI {
    /**
     * Creates new Project Milestone and returns newly created Project Milestone.
     * @summary Creates new Project Milestone.
     * @param {ProjectMilestoneBase} [projectMilestoneBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectMilestonesApi
     */
    public addProjectMilestone(projectMilestoneBase?: ProjectMilestoneBase, options?: AxiosRequestConfig) {
        return ProjectMilestonesApiFp(this.configuration).addProjectMilestone(projectMilestoneBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Project Milestone.
     * @summary Delete Project Milestone.
     * @param {number} entityID Project Milestone identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectMilestonesApi
     */
    public deleteProjectMilestone(entityID: number, options?: AxiosRequestConfig) {
        return ProjectMilestonesApiFp(this.configuration).deleteProjectMilestone(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Project Milestone.
     * @summary Get Project Milestone details.
     * @param {number} entityID Project Milestone identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectMilestonesApi
     */
    public getProjectMilestoneDetails(entityID: number, options?: AxiosRequestConfig) {
        return ProjectMilestonesApiFp(this.configuration).getProjectMilestoneDetails(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of Project Milestones.
     * @summary Get filtered list of Project Milestones.
     * @param {MilestoneType} [type] Milestone type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectMilestonesApi
     */
    public getProjectMilestoneList(type?: MilestoneType, options?: AxiosRequestConfig) {
        return ProjectMilestonesApiFp(this.configuration).getProjectMilestoneList(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Project Milestone and returns the modified Project Milestone.
     * @summary Edit Project Milestone.
     * @param {number} entityID Project Milestone identifier
     * @param {ProjectMilestoneBase} [projectMilestoneBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectMilestonesApi
     */
    public updateProjectMilestone(entityID: number, projectMilestoneBase?: ProjectMilestoneBase, options?: AxiosRequestConfig) {
        return ProjectMilestonesApiFp(this.configuration).updateProjectMilestone(entityID, projectMilestoneBase, options).then((request) => request(this.axios, this.basePath));
    }
}
